import { ErrorMessage, Field, Form, Formik } from 'formik';
import React from 'react';
import SpinnerComponent from '../components/SpinnerComponent';
import * as Yup from 'yup';
import { MentorService } from '../services/mentor.service';
import { Mentor } from '../models/mentor';
import { UploadService } from '../services/upload.service';

interface IState {
    user: Mentor;
    isLoading: boolean;
    isUploading: boolean;
    isEdit: boolean;
}

export class MentorEditPage extends React.Component<any, IState> {

    constructor(props: any) {
        super(props);

        this.state = {
            user: new Mentor(),     
            isLoading: false,
            isUploading: false,
            isEdit: false
          };
    }

    componentDidMount() {
        let id = this.props.match.params.id ? this.props.match.params.id : 0;

        if (id !== 0) {
          this.setState({ isLoading: true });

          MentorService.getById(id)
            .then(
              response => {
                this.setState({
                  user: response,            
                  isLoading: false,
                  isEdit: true
                });
              },
              error => {
                this.setState({ isLoading: false });
              }
            );
        }
    }

    uploadFile = (e) => {
        this.setState({ isUploading: true });

        const file = e.target.files[0] as File;
        const formData = new FormData();
        formData.append("file", file);
        
        UploadService.uploadFile(formData)
            .then((responseText) => responseText)
            .catch(() => {
                this.setState({ isUploading: false });
            })
            .then((response) => {
                // set uploaded image url to data
                let newState = Object.assign({}, this.state.user);
                newState.profilePhotoUrl = response as string;
                this.setState({ user: newState, isUploading: false });
            });
    };

    render() {
        return (
            <div className="col-md-6">
                {this.state.isEdit ? 
                  <h1>Uredi mentora</h1> : <h1>Registracija novog mentora</h1>}
                {this.state.isLoading ? <SpinnerComponent /> : (
                <Formik
                    initialValues={this.state.user}
                    validationSchema={Yup.object().shape({
                        firstName: Yup.string().required('Ime je potrebno'),
                        lastName: Yup.string().required('Prezime je potrebno'),
                        email: Yup.string().required('Email je potreban'),
                        password: this.state.isEdit ? Yup.string() : Yup.string().required('Lozinka je obavezna'),
                        phone: Yup.string().required('Telefon je obavezan')
                    })}
                    onSubmit={(values, { setStatus, setSubmitting, setError }) => {
                        setStatus();
                        setError(null);                                        

                        // set uploaded image URL to form input value
                        values.profilePhotoUrl = this.state.user.profilePhotoUrl;

                        MentorService.createOrUpdate(values)
                            .then(
                                () => {
                                    setSubmitting(false);
                                    setStatus("Uspješno spremljeno!");
                                },
                                error => {
                                    setSubmitting(false);
                                    setError(error);
                                }
                            );
                    }}
                    render={({ errors, status, touched, isSubmitting, error }) => (
                        <Form>
                            <div className="form-group">
                                <label htmlFor="firstName">Ime</label>
                                <Field name="firstName" type="text" className={'form-control' + (errors.firstName && touched.firstName ? ' is-invalid' : '')} />
                                <ErrorMessage name="firstName" component="div" className="invalid-feedback" />
                            </div>
                            <div className="form-group">
                                <label htmlFor="lastName">Prezime</label>
                                <Field name="lastName" type="text" className={'form-control' + (errors.lastName && touched.lastName ? ' is-invalid' : '')} />
                                <ErrorMessage name="lastName" component="div" className="invalid-feedback" />
                            </div>
                            <div className="form-group">
                                <label htmlFor="email">Email</label>
                                <Field name="email" type="email" className={'form-control' + (errors.email && touched.email ? ' is-invalid' : '')} />
                                <ErrorMessage name="email" component="div" className="invalid-feedback" />
                            </div>
                            {!this.state.isEdit &&
                              <div className="form-group">
                                  <label htmlFor="password">Lozinka</label>
                                  <Field name="password" type="password" className={'form-control' + (errors.password && touched.password ? ' is-invalid' : '')} />
                                  <ErrorMessage name="password" component="div" className="invalid-feedback" />
                              </div>
                            }
                            <div className="form-group">
                                <label htmlFor="phone">Telefon</label>
                                <Field name="phone" type="text" className={'form-control' + (errors.phone && touched.phone ? ' is-invalid' : '')} />
                                <ErrorMessage name="phone" component="div" className="invalid-feedback" />
                            </div>
                            <div className="form-group">
                                <label htmlFor="image">Slika mentora</label>
                                <Field name="image" type="file" accept="image/png, image/jpeg" onChange={this.uploadFile} />
                                <ErrorMessage name="image" component="div" className="invalid-feedback" />
                            </div>
                            <div className="form-group">
                                <img src={this.state.user.profilePhotoUrl} style={{maxHeight:200}} />
                            </div>
                            <div className="form-group">
                                {!this.state.isUploading &&
                                    <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                                    {this.state.isEdit ? 
                                        <span>Spremi</span> : <span>Registriraj novog mentora</span>}
                                    </button>
                                }
                                {isSubmitting || this.state.isUploading &&
                                    <SpinnerComponent/>
                                }                                
                            </div>
                            {error &&
                                <div className={'alert alert-danger'}>{error}</div>
                            }
                            {status &&
                                <div className={'alert alert-success'}>{status}</div>
                            }
                        </Form>
                    )}
                />
                )}
                <button
                    className="button icon-left"
                    onClick={this.props.history.goBack}>
                    Povratak
                </button>
            </div>
        )
    }
}